export default class OldErrorHandlerHelper {
  /**
   * @param {string|object} error ??? - error = { error: number; message: string; success: boolean; }
   * @param {object} options
   * @param {boolean} [options.logToConsole]
   * @param {boolean} [options.showSwal]
   * @param {string} [options.swalMessage]
   */
  static handleError(error, options) {
    let swal;
    let internalError = error;
    if(typeof error === `string`) {
      internalError = error.replace(`<br>`, ``);
    }
    if(options.logToConsole) {
      OldErrorHandlerHelper.logError(internalError);
    }
    if(options.showSwal) {
      swal = OldErrorHandlerHelper.prepareAndShowSwal(options, internalError);
    }
    return swal;
  }

  static logError(error) {
    console.groupCollapsed(`logError function was called - ${typeof error === `object` ? error.message : error}`);
    console.trace(error.message ? error.message : error);
    console.info(`Errorcode ${error.error}`);
    console.groupEnd();
  }

  static prepareAndShowSwal(options, error) {
    let swalMessage;
    if(options.swalMessage) {
      swalMessage = options.swalMessage;
    } else if(error.message) {
      swalMessage = JSON.stringify(error.message);
    } else {
      swalMessage = error;
    }
    swalMessage = swalMessage.replace(`<`, `&lt;`).replace(`>`, `&gt;`);
    return window.$swal(``, swalMessage, `error`);
  }
}
